export default {
  language: 'fr',
};
